'use client';

/*──────────────────────────────────────────────────────────────────────
 * AmbientField — one continuous, page-spanning light field.
 *
 * A single fixed layer behind every section. Because the sections paint a
 * translucent veil (--bg-veil) instead of an opaque fill, this indigo glow
 * bleeds through all of them at the same intensity — so section seams stop
 * reading as hard color steps and the hero vortex dissolves into a shared
 * field rather than being clipped at a boundary.
 *
 * Motion is intentionally minimal: two large blobs drift on a long, lazy
 * loop (transform only, GPU-composited). No scroll listeners. Honors
 * prefers-reduced-motion by freezing entirely.
 *──────────────────────────────────────────────────────────────────────*/

export function AmbientField() {
  return (
    <div
      data-ambient
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        opacity: 'var(--field-op, 0.85)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '-14%',
          left: '4%',
          width: 'min(64vw, 900px)',
          height: 'min(64vw, 900px)',
          borderRadius: '50%',
          background:
            'radial-gradient(circle at center, color-mix(in srgb, var(--indigo) 26%, transparent) 0%, transparent 70%)',
          filter: 'blur(64px)',
          animation: 'field-drift-a 38s var(--ease) infinite',
          willChange: 'transform',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-16%',
          right: '0%',
          width: 'min(58vw, 820px)',
          height: 'min(58vw, 820px)',
          borderRadius: '50%',
          background:
            'radial-gradient(circle at center, color-mix(in srgb, var(--indigo-bright) 21%, transparent) 0%, transparent 70%)',
          filter: 'blur(76px)',
          animation: 'field-drift-b 52s var(--ease) infinite',
          willChange: 'transform',
        }}
      />
    </div>
  );
}
